module.exports = __webpack_public_path__ + "img/slice-logo-biack.f1b5970c.svg";